import styled from "styled-components";

export const TopNav = styled.div`
  height: 40px;
  background-color: rgb(0, 118, 189);
  display: flex;
`;

export const TopP = styled.p`
  color: #fff;
  font-size: 18px;
  margin-left: 10%;
  margin-top: 5px;
`;
